import styled from "styled-components";

import { MEDIA_QUERIES } from "context/media/MediaConstant";

// eslint-disable-next-line import/prefer-default-export
export const StyledInnerContainer = styled.div<{ margin?: string }>`
  width: 100%;

  padding: 20px;

  display: flex;
  flex-direction: row;
  align-items: center;

  margin: ${({ margin = "0" }) => margin};

  background-color: ${({ theme }) => theme.colors.secondaryOffWhite};

  border-radius: 8px;

  @media ${MEDIA_QUERIES.MOBILE} {
    flex-direction: column;
  }
`;
